// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"134":"591556d8e5950703","362":"1832e618e04e9484","382":"7697c29c9ddcc8db","621":"ddac7a0d6586f6d1","673":"7a3b82ffb75ef175"}[chunkId] + ".js";
};